{/* Auto-generated icon - do not edit */}
import React from 'react'

interface NavigationIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const NavigationIcon = React.forwardRef<SVGSVGElement, NavigationIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 150 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M78.8943 78.2301C68.0173 78.2301 57.2734 78.4516 46.5421 78.1651C36.0247 77.8865 25.5157 77.1726 15.0145 76.4762C12.0397 76.1735 9.09138 75.6506 6.19357 74.9121C5.0035 74.647 3.87359 74.1605 2.86247 73.4778C0.490128 71.8539 0.669556 69.0074 3.13324 67.5375C3.41764 67.3679 3.72017 67.2276 4.01752 67.0828C28.151 55.1606 52.2255 43.1137 76.4377 31.3564C94.5691 22.5514 112.862 14.0817 131.122 5.54506C134.826 3.8133 138.654 2.31732 142.509 0.951265C146.924 -0.612255 149.877 1.77158 149.173 6.40238C148.39 11.5529 147.27 16.6519 146.276 21.7693C141.918 44.1997 137.749 66.6703 133.104 89.0409C130.852 99.8803 127.652 110.519 124.974 121.272C123.394 127.619 122.168 134.058 120.446 140.363C119.457 143.639 118.162 146.815 116.577 149.847C115.513 152.015 114.083 152.185 111.853 151.151C107.025 148.917 104.06 144.993 102.184 140.217C96.7574 126.398 90.3556 112.967 85.9562 98.7351C83.8281 91.8607 81.2808 85.1168 78.8943 78.2301ZM139.454 10.7396C97.4577 29.0225 56.908 49.1138 16.0956 68.7255C17.163 69.0633 18.2729 69.2458 19.3918 69.2679C32.472 69.3374 45.5542 69.4972 58.6332 69.3809C66.0556 69.316 73.4732 68.7522 80.8954 68.478C83.9253 68.3663 86.078 69.8694 86.3099 72.6912C86.6461 76.79 88.2955 80.4061 89.8173 84.0782C96.7788 100.874 103.775 117.655 110.807 134.42C110.963 134.738 111.152 135.039 111.37 135.318C123.281 94.6376 132.108 53.1574 139.454 10.7416V10.7396Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="149" height="152" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

NavigationIcon.displayName = 'NavigationIcon'
